import { createSelector } from 'reselect'
import { RootState } from 'redux/root-reducer'

const selectLanguage = (state: RootState) => state.language

export const selectCurrentLanguage = createSelector(
  [selectLanguage],
  (language) => language.lang
)
